export default "__VITE_ASSET__DprDxWBm__"